import styled, { keyframes } from "styled-components";

const ticker = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`;

export const TickerWrapper = styled.div`
  width: 100%;
  background: var(--gradient-primary);
  overflow: hidden;
  white-space: nowrap;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1001;
  height: 38px;
  display: flex;
  align-items: center;
  transform: translateY(${(props) => (props.$visible ? "0" : "-100%")});
  transition: transform 0.3s ease;
`;

export const TickerTrack = styled.div`
  display: flex;
  animation: ${ticker} 80s linear infinite;
  will-change: transform;
`;

export const TickerItem = styled.span`
  color: #ffffff;
  font-family: "Montserrat", sans-serif;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  padding: 0 40px;
  flex-shrink: 0;
`;
